import { render, staticRenderFns } from "./StartupEditAIFields.vue?vue&type=template&id=5baffcfe&scoped=true"
import script from "./StartupEditAIFields.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditAIFields.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baffcfe",
  null
  
)

export default component.exports